export default "__VITE_ASSET__BvQxkhAf__"